import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "../style.css";
export default ({ isOpen, toggle }) => (
  <div>
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <strong className="white">
          <b>WORK LTE ALERT!!</b>
        </strong>{" "}
      </ModalHeader>
      <ModalBody>
        <h5 className="">Complete previous course first.</h5>
      </ModalBody>
    </Modal>
  </div>
);
